import React from 'react'
import { 
	FastField,
	Field,
	FieldArray 
} from 'formik'

import TimeInput from './TimeInput'
import NoValue from '@modules/form/components/NoValue'


const days = {
	monday: 'Monday',
	tuesday: 'Tuesday',
	wednesday: 'Wednesday',
	thursday: 'Thursday',
	friday: 'Friday',
	saturday: 'Saturday',
	sunday: 'Sunday',
};

const getEmptyShift = () => ({
	start: '',
	end: '',
})

const TimeDisplay = ({ field }) => {
	return <div className="TimeDisplay">{field.value ? field.value : '-'}</div>
}

const Shift = ({ name, TimeComponent }) => (
	<div className="Shift" data-component={TimeComponent.name}>
		<FastField name={`${name}.start`} component={TimeComponent} placeholder="from" />
		<span className="Shift-divider">-</span>
		<FastField name={`${name}.end`} component={TimeComponent} placeholder="to" />
	</div>
)

export default
class Availability extends React.Component {
	render() {
		const { field, form, isEditing } = this.props;

		const TimeComponent = isEditing ? TimeInput : TimeDisplay;

		return (
			<div className='Availability'>
			{
				Object.keys(days).map(key => {
					return (
						<div key={key} className={`Availability-day ${isEditing ? 'isEditing' : ''}`}>
							<div className="Availability-dayLabel">{days[key]}</div>
							<div className="Availability-shifts">
								<FieldArray name={`${field.name}.${key}`}>
									{({ push, pop }) => {
										var shifts = form.values[field.name][key];

										if(!shifts) {
											return '';
										}
									
										return (
											<React.Fragment>
												{shifts.map((shift, idx) => 
													isEditing || (shift.start && shift.end)
													? <Shift key={idx} name={`${field.name}.${key}.${idx}`} TimeComponent={TimeComponent} />
													: <NoValue key={idx} />
												)}
												{
													isEditing &&
													<div className="Availability-shiftButtons">
														{ shifts.length > 1 &&
															<button className="button-link" type="button" className="btn btn-primary" onClick={() => pop()}>- remove a shift</button>
														}

														<button className="button-link" type="button" className="btn btn-primary" onClick={() => push(getEmptyShift())}>+ add another shift</button>
													</div>
												}
											</React.Fragment>
										)

									}}
								</FieldArray>
							</div>
						</div>
					)
				})
			}
			</div>
		)
	}

	// renderDisplay() {
	// 	return <div>Display Those shifts</div>
	// }
}


// WEBPACK FOOTER //
// ./src/modules/form/components/input/Availability.jsx